export default __webpack_public_path__ + "static/media/logo-white.9e516315.png";